import { ThreeDots } from "react-loader-spinner";

export function ThreeDotsLoader() {
    return (
        <div className="d-flex justify-content-center">
            <ThreeDots
                visible={true}
                height="80"
                width="80"
                color="#e8e8e8"
                radius="9"
                ariaLabel="three-dots-loading"
            />
        </div>
    );
}

ThreeDotsLoader.Page = function PageLoader() {
    return (
        <div className="d-flex justify-content-center align-items-center h-100 w-100">
            <ThreeDots
                visible={true}
                height="80"
                width="80"
                color="#e8e8e8"
                radius="9"
                ariaLabel="three-dots-loading"
            />
        </div>
    );
};

export function ReactiveBuilder({ loading, children }) {
    if (loading) return <ThreeDotsLoader />;
    return children;
}

ReactiveBuilder.Page = function PageReactiveBuilder({ loading, children }) {
    if (loading) return <ThreeDotsLoader.Page />;
    return children;
};
